import { Request } from 'commons/utils/request'

import { PCTPayload } from '../types/PCT'

export const getParsedTransactions = (filter: PCTPayload) => Request.post(Request.urls.bank.parsedTransactions, filter)
